import { render, staticRenderFns } from "./EditCorreduria.vue?vue&type=template&id=33329ce2&scoped=true"
import script from "./EditCorreduria.vue?vue&type=script&lang=js"
export * from "./EditCorreduria.vue?vue&type=script&lang=js"
import style0 from "./EditCorreduria.vue?vue&type=style&index=0&id=33329ce2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33329ce2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33329ce2')) {
      api.createRecord('33329ce2', component.options)
    } else {
      api.reload('33329ce2', component.options)
    }
    module.hot.accept("./EditCorreduria.vue?vue&type=template&id=33329ce2&scoped=true", function () {
      api.rerender('33329ce2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/staff/corredurias/EditCorreduria.vue"
export default component.exports